import { useMemo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Box, Column } from 'seagull';
import { getVendorGradientStyle } from "../../../ClientOnboardingV2.utils";
import { Footer } from "../../Footer/Footer";
import { Header } from "../../Header/Header";
import { contentTransition, contentVariants } from "../animations";
import { StepContent } from "../StepContent";
import { GetStepsContainerTID } from "./StepsContainer";
import styles from "./StepsContainerDesktop.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const StepsContainerDesktop = _ref => {
  let {
    testId,
    currentStep,
    direction,
    onBack,
    onNext,
    relationship
  } = _ref;
  const {
    StepsContainerTestIds
  } = useMemo(() => GetStepsContainerTID(testId), [testId]);
  const gradientStyle = getVendorGradientStyle(relationship.vendor.branding);
  return /*#__PURE__*/_jsx(Box, {
    className: styles.gradientWrapper,
    style: gradientStyle,
    "data-testid": StepsContainerTestIds.Root(),
    children: /*#__PURE__*/_jsxs(Column, {
      className: styles.inner,
      children: [/*#__PURE__*/_jsx(Header, {
        currentStep: currentStep,
        relationship: relationship,
        onBack: onBack,
        testId: testId
      }), /*#__PURE__*/_jsx(Column, {
        className: styles.content,
        "data-testid": StepsContainerTestIds.Content(),
        children: /*#__PURE__*/_jsx(Column, {
          className: styles.contentInner,
          children: /*#__PURE__*/_jsx(AnimatePresence, {
            initial: false,
            mode: "wait",
            custom: direction,
            children: /*#__PURE__*/_jsx(motion.div, {
              custom: direction,
              variants: contentVariants,
              initial: "enter",
              animate: "center",
              exit: "exit",
              transition: contentTransition,
              children: /*#__PURE__*/_jsx(StepContent, {
                currentStep: currentStep
              })
            }, currentStep)
          })
        })
      }), /*#__PURE__*/_jsx(Footer, {
        currentStep: currentStep,
        relationship: relationship,
        onNext: onNext,
        testId: testId
      })]
    })
  });
};